import { render, staticRenderFns } from "./HotelsComponent.vue?vue&type=template&id=79b50270&scoped=true&"
import script from "./HotelsComponent.vue?vue&type=script&lang=js&"
export * from "./HotelsComponent.vue?vue&type=script&lang=js&"
import style0 from "./HotelsComponent.vue?vue&type=style&index=0&id=79b50270&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b50270",
  null
  
)

export default component.exports